import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=ba0ec0ae&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=ts"
export * from "./newsDetail.vue?vue&type=script&lang=ts"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=ba0ec0ae&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ec0ae",
  null
  
)

export default component.exports